import Spinner from '@/shared/components/ui/spinner';

const SharedCollectionDetail = () => {
  return (
    <div className="h-[calc(100vh-400px)] flex items-center justify-center animate-fadeIn">
      <Spinner size={26} />
    </div>
  );
};

export default SharedCollectionDetail;
